import { InputTemplateAttachment, isInlineAttachment, isInlinePlacement } from '@hb/shared'
import 'react-pdf/dist/Page/AnnotationLayer.css'
import 'react-pdf/dist/Page/TextLayer.css'
import './styles.css'

export const sortInputAttachments = (inputAttachments: InputTemplateAttachment[]) =>
  inputAttachments.sort((a, b) => {
    if (isInlineAttachment(a) && isInlineAttachment(b)) {
      const pageDiff = a.placement.pageIndex - b.placement.pageIndex
      if (pageDiff !== 0) {
        return pageDiff
      }
      const heightDiff = Math.abs(
        a.placement.orientation.position[1] - b.placement.orientation.position[1],
      )
      if (heightDiff < 10) {
        return a.placement.orientation.position[0] > b.placement.orientation.position[0] ? 1 : -1
      }
      return a.placement.orientation.position[1] > b.placement.orientation.position[1] ? 1 : -1
    }
    if (isInlineAttachment(a) && !isInlinePlacement(b.placement)) {
      return b.placement.afterPageIndex >= a.placement.pageIndex ? 1 : -1
    }
    if (!isInlinePlacement(a.placement) && isInlineAttachment(b)) {
      return a.placement.afterPageIndex >= b.placement.pageIndex ? 1 : -1
    }
    if (!isInlinePlacement(a.placement) && !isInlinePlacement(b.placement)) {
      return a.placement.afterPageIndex - b.placement.afterPageIndex
    }
    return 0
  })
